module.exports = __webpack_public_path__ + "img/kaist_gallery5.2663c955.jpg";